module.exports = __webpack_public_path__ + "static/media/round.951b37e7.png";